import { render, staticRenderFns } from "./MarketplaceListing.vue?vue&type=template&id=39c455e6"
import script from "./MarketplaceListing.vue?vue&type=script&lang=js"
export * from "./MarketplaceListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports